module.exports = __webpack_public_path__ + "static/img/4.d0f8909.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nationalDay/card/4.png
// module id = 9GT9
// module chunks = 2